<span [style.background]="params()?.value" class="color-cell"></span>
